<template>
  <div>
    <PanelGroup :key="group.id" v-for="group in groups" :heading="group.label">
      <PanelGroupCheckbox
        :key="item.id"
        v-for="item in group.items"
        :active="item.active"
        @change="active => $emit('change', group.id, item.id, active)"
      >
        <span v-html="item.label" />
      </PanelGroupCheckbox>
    </PanelGroup>
  </div>
</template>

<script>
import PanelGroup from "../PanelGroup/PanelGroup";
import PanelGroupCheckbox from "../PanelGroupCheckbox/PanelGroupCheckbox";

export default {
  name: "MapFilter",
  components: {
    PanelGroup,
    PanelGroupCheckbox
  },
  props: {
    groups: {
      type: Array,
      default: () => []
    }
  }
};
</script>
